import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import useLocales from 'hooks/useLocales';
import ProfileSettings from './Profile/Index';
import Popup from '../Popup/Index';
import AvatarPopup from '../Avatar/Index';
import { ISettingsPopup } from 'core/interface/profileSettings';
import { IMe } from 'core/interface/me';

import './Index.scss';

interface ISettingsPopupWithPopup extends ISettingsPopup {
  isForActivationStep?: boolean;
  setCompanyData?: (data: any) => void;
  companyData?: any;
  errors?: any;
  touched?: any;
}

const SettingsPopup: FC<ISettingsPopupWithPopup> = ({
  handleClosePopup,
  isForActivationStep = false,
  setCompanyData,
  companyData,
  errors,
  touched
}): JSX.Element => {
  const { t } = useLocales();
  const me = useSelector((state: IMe) => state.user).user;
  const [avatarEditModal, setAvatarEditModal] = useState<boolean>(false);

  const openAvatarModal = (): void => {
    setAvatarEditModal(!avatarEditModal);
  };

  if (!isForActivationStep) {
    return (
      <Popup title={t('settings')} onClose={handleClosePopup}>
        <div className="settings">
          <div className="settings__content">
            <ProfileSettings
              handleClosePopup={handleClosePopup}
              openAvatarModal={openAvatarModal}
              isForActivationStep={false}
              setCompanyData={setCompanyData}
              companyData={companyData}
            />
          </div>
          {avatarEditModal && (
            <Popup
              onClose={openAvatarModal}
              title={t('Edit Your Profile Image')}
            >
              <AvatarPopup id={me.id} onPopupClose={openAvatarModal} t={t} />
            </Popup>
          )}
        </div>
      </Popup>
    );
  }
  return (
    <div className="settings">
      <div className="settings__content">
        <ProfileSettings
          handleClosePopup={handleClosePopup}
          openAvatarModal={openAvatarModal}
          isForActivationStep={true}
          setCompanyData={setCompanyData}
          companyData={companyData}
        />
      </div>
    </div>
  );
};

export default SettingsPopup;
